import { useMutation, useQueryClient } from '@tanstack/vue-query';
import * as SubscriptionApi from '@/api/subscription';
import { MutationConfig } from '@/types';
import { queries } from '@/api/queries';
import { NormalizedSubscriptions } from '@pasta-evangelists/pasta-types';
import merge from 'lodash.merge';

type SkipOptions = {
  config?: MutationConfig<typeof SubscriptionApi.activateSubscription>;
};

const useActivateSubscription = ({ config }: SkipOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: SubscriptionApi.activateSubscription,
    onSuccess: result => {
      queryClient.setQueriesData<NormalizedSubscriptions>(
        queries.subscriptions.all,
        subscriptions => {
          return merge({}, subscriptions, result);
        }
      );
      queryClient.invalidateQueries(queries.subscriptions.all);
      queryClient.invalidateQueries(queries.orders.scheduleWeeks);
      queryClient.invalidateQueries(queries.orders.upcoming);
    },
  });
};

export default useActivateSubscription;
